import type { SVGProps } from 'react'
const SolidGoogle = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width={25}
		height={24}
		viewBox="0 0 25 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<g clipPath="url(#clip0_26600_38639)">
			<path
				d="M12.6665 9.81815V14.4654H19.1247C18.8411 15.96 17.9901 17.2255 16.7137 18.0764L20.6082 21.0982C22.8773 19.0037 24.1864 15.9273 24.1864 12.2728C24.1864 11.4219 24.1101 10.6037 23.9682 9.81828L12.6665 9.81815Z"
				fill="#4285F4"
			/>
			<path
				d="M5.94112 14.284L5.06276 14.9564L1.95361 17.3782C3.92815 21.2945 7.97513 24 12.666 24C15.9059 24 18.6227 22.9309 20.6082 21.0982L16.7137 18.0764C15.6446 18.7964 14.2805 19.2328 12.666 19.2328C9.54602 19.2328 6.89518 17.1273 5.94602 14.291L5.94112 14.284Z"
				fill="#34A853"
			/>
			<path
				d="M1.95368 6.62183C1.13555 8.23631 0.666504 10.0581 0.666504 11.9999C0.666504 13.9417 1.13548 15.7637 1.95361 17.3782C1.95361 17.389 5.94648 14.2799 5.94648 14.2799C5.70648 13.5599 5.56462 12.7963 5.56462 11.9998C5.56462 11.2033 5.70648 10.4398 5.94648 9.71976L1.95368 6.62183Z"
				fill="#FBBC05"
			/>
			<path
				d="M12.6662 4.77818C14.4335 4.77818 16.0044 5.38907 17.259 6.56727L20.6953 3.13095C18.6117 1.18916 15.9063 0 12.6662 0C7.97537 0 3.92822 2.69454 1.95368 6.62183L5.94648 9.71976C6.89551 6.88336 9.54626 4.77818 12.6662 4.77818Z"
				fill="#EA4335"
			/>
		</g>
		<defs>
			<clipPath id="clip0_26600_38639">
				<rect
					width="24"
					height="24"
					fill="white"
					transform="translate(0.666504)"
				/>
			</clipPath>
		</defs>
	</svg>
)
export { SolidGoogle }
